import script from "./JournalClaspSlip.vue?vue&type=script&setup=true&lang=js"
export * from "./JournalClaspSlip.vue?vue&type=script&setup=true&lang=js"

import "./JournalClaspSlip.vue?vue&type=style&index=0&id=6d5275f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d5275f0"]])

export default __exports__